import { useQuery } from "@tanstack/react-query";
import { getPaymentMethods } from "@/services/student/checkout/checkout.service";
import { CHECKOUT_QUERY_KEYS } from "../../CheckoutContext";

export const usePaymentMethods = () =>
  useQuery({
    queryKey: [...CHECKOUT_QUERY_KEYS.packages, "payment-methods"] as const,
    queryFn: getPaymentMethods,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
